import ResourceService from "./resource.service";

class MonthlyDataService extends ResourceService {
  static get resource() {
    return "admin/analytics/monthlydata";
  }
}

export default MonthlyDataService;
